import { forwardRef } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';
import { useTheme } from 'styled-components/macro';

export const Arrow = forwardRef(() => {
  const theme = useTheme();

  return (
    <RadixPopover.Arrow asChild>
      <svg
        width="17"
        height="8"
        viewBox="0 0 17 8"
        fill={theme.semantic.bg.surface}
        strokeWidth={1}
        stroke={theme.semantic.border.default}
        xmlns="http://www.w3.org/2000/svg"
        className="popover-arrow"
      >
        <path d="M17 -0.00868225L9.93175 7.06521C9.15102 7.84657 7.88469 7.84707 7.10333 7.06633L0.029439 -0.00191164L8.51133 -8.49058L17 -0.00868225Z" />
      </svg>
    </RadixPopover.Arrow>
  );
});
